import classes from '../CMSMarkdownEditor.module.scss';

const Toolbar = ({ onClickHandler }) => {
	return (
		<div className={classes['toolbar__container--vert']}>
			<button onClick={() => onClickHandler('B')}>
				<strong>B</strong>
			</button>
			<button onClick={() => onClickHandler('I')}>
				<em>I</em>
			</button>
			<button onClick={() => onClickHandler('CODE')}>
				<code>{'</>'}</code>
			</button>
			<button
				onClick={() => onClickHandler('H1')}
			>
				<h1>H1</h1>
			</button>
			<button onClick={() => onClickHandler('H2')}>
				<h2>H2</h2>
			</button>
			<button onClick={() => onClickHandler('H3')}>
				<h3>H3</h3>
			</button>
			<button onClick={() => onClickHandler('LI')}>
				<ul>
					<li>&nbsp;</li>
				</ul>
			</button>
			<button onClick={() => onClickHandler('LINK')}>LINK</button>
		</div>
	);
};
export default Toolbar;
